import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icons } from 'team-hero-ui';
import { Link } from 'react-router';

import type { TLocale } from 'interfaces/Locale.interface';
import type { IFormStepProps } from './FormStep.types';
import type { ICustomFields } from 'interfaces/CustomFields.interface';
import {
  BackButtonWrapperStyled,
  StepWrapperStyled,
} from '../../JobAdApplyForm.styled';
import { Form } from '../Form/Form';
import { FormSectionRenderer } from '../FormSection/FormSectionRenderer';
import FormHeader from '../FormHeader';
import { useGetPublicSystemSettingsQuery } from 'services/publicTeamHeroApi.service';
import { customFieldsService } from 'services/customFields/customFields.service';
import FormFooter from '../FormFooter';

const FormStep: FC<IFormStepProps> = ({
  isFirstStep,
  isLastStep,
  jobAds,
  control,
  section,
  selectedJobAd,
  sourceTitle,
  onBackClick,
  onNextClick,
  disabled = false,
}) => {
  const { t, i18n } = useTranslation(['general', 'form']);

  const { data: publicSettingsData } = useGetPublicSystemSettingsQuery();
  const formLogoUrl =
    publicSettingsData?.settings?.branding?.client_logo?.file || '';
  const formPrivacyTermsLink =
    publicSettingsData?.settings?.privacy_policy_url || '';
  const formCustomFields = publicSettingsData as unknown as
    | ICustomFields
    | undefined;

  const customFields = customFieldsService({
    customFields: formCustomFields,
    language: i18n.languages[0] as TLocale,
  }).getCustomFieldsJobAdForm();

  return (
    <StepWrapperStyled>
      <BackButtonWrapperStyled>
        <Button
          size='large'
          color='borderGrey'
          startIcon={<Icons.ArrowLeftIcon svgSize={24} />}
          component={Link}
          componentProps={{ to: `/job` }}
        >
          {t('jobAdForm.backToListing')}
        </Button>
      </BackButtonWrapperStyled>
      <FormHeader
        control={control}
        jobAds={jobAds}
        logoUrl={formLogoUrl}
        selectedJobAd={selectedJobAd}
        sourceTitle={sourceTitle}
      />
      <Form
        isLastStep={isLastStep}
        onBackClick={onBackClick}
        onNextClick={onNextClick}
        title={section.title}
        disabled={disabled}
      >
        <>
          <FormSectionRenderer
            key={section?.title}
            control={control}
            section={section}
          />
          {isFirstStep &&
            customFields.map((customSection) => {
              return (
                <FormSectionRenderer
                  key={customSection?.title}
                  control={control}
                  section={customSection}
                />
              );
            })}
        </>
        {isLastStep && (
          <FormFooter
            control={control}
            privacyTermsLink={formPrivacyTermsLink}
          />
        )}
      </Form>
    </StepWrapperStyled>
  );
};

export default FormStep;
